module.exports = __webpack_public_path__ + "img/empreendimento-logo-2.8b37c872.png";